import { Component, OnInit, Input, Output, EventEmitter, forwardRef } from '@angular/core';

import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR
} from '@angular/forms';

@Component({
  selector: 'app-a-form-input-field',
  templateUrl: './a-form-input-field.component.html',
  styleUrls: ['./a-form-input-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AFormInputFieldComponent),
      multi: true
    }
  ]
})
export class AFormInputFieldComponent implements ControlValueAccessor {

  private _value: string;
  private isInitialized = false;

  @Input() label: string;
  @Input() id: string;
  @Input() description: string;
  @Input() required: boolean;
  @Input() validate: string;
  @Input() type = 'text';
  @Input() autocomplete: string;
  @Input() placeholder: string = '';
  @Input() readonly: boolean = false;
  @Input() creditCardType: string;
  @Input() constraintsInfos: string;
  @Output() InputChange = new EventEmitter<string>();

  @Input()
  set value(val: string) {
    this._value = val;
    if (this.isInitialized) {
      this.onChange(this._value);
      this.InputChange.emit(this._value);
    }
    setTimeout(() =>
      this.isInitialized = true
    , 500)
  }
  get value(): string {
    return this._value;
  }

  private onChange = (value: any) => {};
  private onTouched = () => {};

  writeValue(value: any): void {
    this.value = value ?? '';
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onInputChange(event: Event): void {
    this._value = (event.target as HTMLInputElement).value;
    this.value = this._value;
    this.onChange(this._value);
    this.InputChange.emit(this._value);
  }
}
